import React from 'react';
import { JSX } from 'react/jsx-runtime';

const AlarmClockDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7163 0.989258C10.9543 0.786671 11.3014 0.765294 11.5601 0.970703H11.561L12.7612 1.89551L12.7622 1.89746L12.8599 1.99219C13.034 2.19667 13.075 2.48134 12.9526 2.72168L12.8774 2.83789L12.8765 2.83887C12.735 3.00861 12.5583 3.1005 12.3501 3.10059C12.1993 3.10059 12.0536 3.04028 11.9399 2.95508L11.938 2.9541L10.7632 2.02832H10.7622C10.4723 1.79634 10.4116 1.38721 10.6177 1.09277L10.6216 1.08789L10.7163 0.989258Z"
        fill="#EEF7FF"
        stroke="#EEF7FF"
        stroke-width="0.2"
      />
      <path
        d="M2.55322 0.897461C2.83362 0.754516 3.17514 0.833794 3.37842 1.08789C3.61491 1.38378 3.55242 1.79615 3.26221 2.02832L3.26123 2.0293L2.06104 2.9541L2.06006 2.95508C1.94643 3.0403 1.80072 3.10059 1.6499 3.10059C1.4485 3.10054 1.23876 3.01397 1.1167 2.83105V2.83008C0.888512 2.53696 0.946207 2.1255 1.24268 1.91797L2.43799 0.97168L2.55322 0.897461Z"
        fill="#EEF7FF"
        stroke="#EEF7FF"
        stroke-width="0.2"
      />
      <path
        d="M7 2.02539C10.5802 2.02539 13.4746 4.91977 13.4746 8.5C13.4746 10.4681 12.5932 12.2385 11.1934 13.4316L12.7207 15.0547L12.7676 15.1064C12.9835 15.3762 12.9408 15.7783 12.6914 16L12.6904 15.999C12.569 16.1177 12.3955 16.1748 12.25 16.1748C12.0857 16.1748 11.8778 16.1213 11.751 15.9668V15.9678L10.1279 14.1992C9.20444 14.7081 8.13966 14.9999 7.02539 15C5.88605 15 4.84337 14.7084 3.9209 14.1992L2.29883 15.9678L2.2959 15.9707C2.15018 16.1164 1.97341 16.1748 1.7998 16.1748C1.68935 16.1748 1.56203 16.1428 1.4541 16.0752L1.35449 15.9961C1.09108 15.7327 1.091 15.3221 1.3252 15.0586L1.32617 15.0576L2.80664 13.4326C1.40653 12.2395 0.525391 10.4683 0.525391 8.5C0.525391 4.91977 3.41977 2.02539 7 2.02539ZM7 3.34961C4.15523 3.34961 1.84961 5.65523 1.84961 8.5C1.84961 11.3448 4.15523 13.6504 7 13.6504C9.84477 13.6504 12.1504 11.3448 12.1504 8.5C12.1504 5.65523 9.84477 3.34961 7 3.34961Z"
        fill="#EEF7FF"
        stroke="#EEF7FF"
        stroke-width="0.2"
      />
      <path
        d="M6.9751 4.90039C7.35802 4.9005 7.6499 5.22286 7.6499 5.5752V7.8252H9.99951C10.3576 7.8252 10.6499 8.12269 10.6499 8.5C10.6499 8.88295 10.3274 9.1747 9.9751 9.1748H6.9751C6.59208 9.1748 6.30029 8.85239 6.30029 8.5V5.5752L6.31396 5.43555C6.38067 5.12325 6.66687 4.90039 6.9751 4.90039Z"
        fill="#EEF7FF"
        stroke="#EEF7FF"
        stroke-width="0.2"
      />
    </svg>
  );
};

export default AlarmClockDark;
